var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m1.814 19.678 1.059 1.828c.22.385.536.687.907.907l3.78-6.543H0c0 .427.11.853.33 1.238l1.484 2.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "M12 8.173 8.22 1.63c-.371.22-.687.522-.907.907L.33 14.633c-.216.377-.33.803-.33 1.237h7.56L12 8.173Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M20.22 22.413c.371-.22.687-.522.907-.907l.44-.756 2.103-3.642c.22-.385.33-.811.33-1.238h-7.561l1.609 3.162 2.172 3.381Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m12 8.173 3.78-6.543c-.371-.22-.797-.33-1.237-.33H9.457c-.44 0-.866.124-1.237.33L12 8.173Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M16.44 15.87H7.56l-3.78 6.543c.371.22.797.33 1.237.33h13.966c.44 0 .866-.123 1.237-.33l-3.78-6.543Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m20.179 8.585-3.492-6.048c-.22-.385-.536-.687-.907-.907L12 8.173l4.44 7.697h7.546c0-.426-.11-.852-.33-1.237l-3.477-6.048Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/google_drive.36be4e09a90a271d74cfb59582ff2de3.svg";
export { ForwardRef as ReactComponent };